import { TextField } from '@mui/material';

const CustomTextField = ({ 
  autoFocus = false, 
  slotProps = {}, 
  ...props 
}) => {
  return (
    <TextField
      {...props}
      autoFocus={autoFocus}
      slotProps={autoFocus ? {
        ...slotProps,
        input: {
          ...slotProps.input,
          onFocus: (e) => {
            slotProps.input?.onFocus?.(e);
            const { target } = e;
            if (target?.setSelectionRange) {
              target.setSelectionRange(target.value?.length || 0, target.value?.length || 0);
            }
          }
        }
      } : slotProps}
    />
  );
};

export default CustomTextField;
